<script>
import Modal from '../../../components/Modal.vue'

export default {
    components: {
        Modal
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        message: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            fail_reason: '',
            manual_pass: false,
            isSubmitted: false,
        }
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        },
        pass() {
            this.isSubmitted = true
            this.$emit('submit', {
                manual_pass: this.manual_pass
            })
        }
    },

    watch: {
        manual_pass: function (val) {
            this.$emit('backgroundCheck', {
                manual_pass: val
            })
        },
    },
}
</script>

<template>
    <modal ref="modal" heading="Pass Applicant">
        <div class="mb-4">
            <h5>{{ this.manual_pass ? 'Are you sure? None of the iFacts checks will be sent. All results will be available in the next stage.' : message }}</h5>
        </div>

        <div class="grid-x grid-padding-x align-right">
            <div class="cell auto">
                <div class="input checkbox required cell terms">
                    <input type="checkbox" name="keep_me_login" v-model="manual_pass" value="1" id="l_login_keep">
                    <label for="l_login_keep">I confirm that I have manually sent the iFacts and understand that the system will not send them on my behalf</label>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x align-right">
            <div class="cell shrink">
                <div class="grid-x grid-padding-x align-right">
                    <div class="cell shrink">
                        <button :disabled="isSubmitted" class="button success" type="button" @click="pass">Pass</button>
                    </div>
                    <div class="cell shrink">
                        <button class="button warning" type="button" @click="toggleModal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<style scoped>
.checkbox-group {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
}
</style>